module.exports = __webpack_public_path__ + "images/emoji/oden.a8dfb8a465d04caadfbb.png";